/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react'
import {
  InfoBanner,
  useTrustPlaceholderEnabled,
  isTrustCardNumberExist,
} from '@ntuctech/payment-sdk-react'
import { TRUST_CARD_MESSAGES } from '../../utils/constants/general'
import Image from '../../components/Image'
import nookies from 'nookies'
import { AUTH_TOKEN_KEY } from '../../utils/constants'
import { GTM_ENV_VAR as GEV } from '../../lib/eventTrackerFunction'

const CheckoutInfoBanner = ({
  selectedCardNumber,
  cards = [],
  reloadHook = '',
  isAcccountPage,
  track,
}) => {
  const authToken = nookies.get({})[AUTH_TOKEN_KEY]
  const [trustBannerHeader, setTrustBannerHeader] = React.useState('')
  const [trustBannerBody, setTrustBannerBody] = React.useState('')
  const [bannerHide, setBannerHide] = React.useState(false)
  const { haveTrustCard, isTrustCardAdded, TrustPlacementConfig } =
    useTrustPlaceholderEnabled(authToken, cards, reloadHook)

  const isTrustCardSelected =
    !isAcccountPage &&
    selectedCardNumber &&
    isTrustCardNumberExist(selectedCardNumber, TrustPlacementConfig)

  const trustHeaderBody = bannerType => {
    switch (bannerType) {
      case 'isTrustCardAdded':
        setBannerHide(false)
        setTrustBannerHeader(TRUST_CARD_MESSAGES.payHeader)
        setTrustBannerBody(TRUST_CARD_MESSAGES.body)
        if (!isAcccountPage && track) {
          track({
            [GEV.EVENT_CAT]: 'order-checkout',
            [GEV.EVENT_ACTION]: 'landed',
            [GEV.EVENT_LABEL]: 'Payment_Pay_With_Trust_Banner',
            [GEV.PAGE_TYPE]: 'Checkout',
            [GEV.SCREEN_NAME]: 'grocery-online | checkout',
            [GEV.EVENT]: 'hm_push_event',
          })
        }
        break
      case 'haveTrustCard':
        setBannerHide(false)
        setTrustBannerHeader(
          isAcccountPage
            ? TRUST_CARD_MESSAGES.accountAddHeader
            : TRUST_CARD_MESSAGES.addHeader
        )
        setTrustBannerBody(TRUST_CARD_MESSAGES.addBody)
        if (!isAcccountPage && track) {
          track({
            [GEV.EVENT_CAT]: 'order-checkout',
            [GEV.EVENT_ACTION]: 'landed',
            [GEV.EVENT_LABEL]: 'Payment_Add_Card_Trust_Banner',
            [GEV.PAGE_TYPE]: 'Checkout',
            [GEV.SCREEN_NAME]: 'grocery-online | checkout',
            [GEV.EVENT]: 'hm_push_event',
          })
        }
        break
      default:
        setBannerHide(true)
    }
  }

  React.useEffect(() => {
    if (isTrustCardSelected || (!haveTrustCard && !isTrustCardAdded)) {
      trustHeaderBody('')
    } else if (isTrustCardAdded) {
      trustHeaderBody('isTrustCardAdded')
    } else if (haveTrustCard) {
      trustHeaderBody('haveTrustCard')
    }
  }, [
    isTrustCardAdded,
    haveTrustCard,
    authToken,
    bannerHide,
    isTrustCardSelected,
    cards,
  ])

  return (
    <InfoBanner
      header={trustBannerHeader}
      body={trustBannerBody}
      className="trust-banner"
      icon={
        <Image
          src="https://storage.googleapis.com/fpon-mobile-assets/linkpay_email_assets/TrustVertical%201.svg"
          alt="trust bank"
        />
      }
      hideBanner={bannerHide}
    />
  )
}

export default CheckoutInfoBanner
